import { IPaymentRepository } from '../interfaces';
import LogUtil from '../../../core/utils/LogUtil';

/**
 * Payment Repository Implementation
 * 결제 관리 API 호출 구현체
 */
export class PaymentRepositoryImpl extends IPaymentRepository {
  constructor(apiClient) {
    super();
    this.apiClient = apiClient;
    LogUtil.log('🔧 [PaymentRepository] 초기화 완료');
  }

  /**
   * KSPAY 결제 결과 콜백
   * POST /payment/kspay/callback
   */
  async kspayCallback(data) {
    try {
      LogUtil.log('📤 [PaymentRepository] KSPAY 콜백 요청:', data);
      const response = await this.apiClient.post('/payment/kspay/callback', data);
      LogUtil.log('📥 [PaymentRepository] KSPAY 콜백 응답:', response);
      return response;
    } catch (error) {
      LogUtil.error('❌ [PaymentRepository] KSPAY 콜백 실패:', error);
      throw new Error(`KSPAY 콜백 실패: ${error.message}`);
    }
  }

  /**
   * 결제 정보 조회
   * GET /payment/{payment_id}
   */
  async getPayment(paymentId) {
    try {
      LogUtil.log('📤 [PaymentRepository] 결제 정보 조회 요청:', paymentId);
      const response = await this.apiClient.get(`/payment/${paymentId}`);
      LogUtil.log('📥 [PaymentRepository] 결제 정보 조회 응답:', response);
      return response;
    } catch (error) {
      LogUtil.error('❌ [PaymentRepository] 결제 정보 조회 실패:', error);
      throw new Error(`결제 정보 조회 실패: ${error.message}`);
    }
  }

  /**
   * 주문별 결제 정보 조회
   * GET /payment/order/{order_id}
   */
  async getPaymentByOrder(orderId) {
    try {
      LogUtil.log('📤 [PaymentRepository] 주문별 결제 조회 요청:', orderId);
      const response = await this.apiClient.get(`/payment/order/${orderId}`);
      LogUtil.log('📥 [PaymentRepository] 주문별 결제 조회 응답:', response);
      return response;
    } catch (error) {
      LogUtil.error('❌ [PaymentRepository] 주문별 결제 조회 실패:', error);
      throw new Error(`주문별 결제 조회 실패: ${error.message}`);
    }
  }
}
